// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1UtmJ","header":"PatientQuestionnaire_header__3W24B","info":"PatientQuestionnaire_info__mJO9t"};